import { render, staticRenderFns } from "./MpmInput.vue?vue&type=template&id=a12aa19c&scoped=true"
import script from "./MpmInput.vue?vue&type=script&lang=js"
export * from "./MpmInput.vue?vue&type=script&lang=js"
import style0 from "./MpmInput.vue?vue&type=style&index=0&id=a12aa19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12aa19c",
  null
  
)

export default component.exports